export enum ContractsEnum{
    Approved=12,
    Completed=13,
    Pending=14,
    Rejected=15
}